import { summarizeVerification, type FactState, type PlaceVerification } from '@antoja/shared';
import { t } from '../i18n';
import { Icon, type IconName } from '../icons';
import { formatDate } from './format';

const stateIcons: Record<PlaceVerification, IconName> = {
  verified: 'check',
  single_source: 'oneSource',
  conflicting: 'conflict',
  expired: 'expired',
  none: 'none',
};

/** A verification state as a line icon plus its word: never only a color (antoja-marca). */
export function StateWithIcon({ state, label }: { state: PlaceVerification; label: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap ${
        state === 'verified' ? 'font-medium' : ''
      }`}
    >
      <Icon name={stateIcons[state]} size={16} />
      {label}
    </span>
  );
}

export function VerificationLabel({ facts }: { facts: readonly FactState[] }) {
  const state = summarizeVerification(facts);
  return <StateWithIcon state={state} label={t(`verification.${state}`)} />;
}

export function AppLabel({
  isPublished,
  hiddenUntil,
}: {
  isPublished: boolean;
  hiddenUntil: string | null;
}) {
  if (hiddenUntil && new Date(hiddenUntil) > new Date()) {
    return <span>{t('inApp.hiddenUntil', { date: formatDate(hiddenUntil) })}</span>;
  }
  return <span>{isPublished ? t('inApp.published') : t('inApp.unpublished')}</span>;
}
